/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown> }} Scl_New_Source_RemainingInputs */

const vi_scl_new_source_remaining = /** @type {(inputs: Scl_New_Source_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`còn ${i?.qty} kg`)
};

/**

* @param {Scl_New_Source_RemainingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_new_source_remaining = /** @type {((inputs: Scl_New_Source_RemainingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_New_Source_RemainingInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_new_source_remaining(inputs)
});